import { render, staticRenderFns } from "./combustion-categories.vue?vue&type=template&id=0aea9578&scoped=true"
import script from "./combustion-categories.vue?vue&type=script&lang=js"
export * from "./combustion-categories.vue?vue&type=script&lang=js"
import style0 from "./combustion-categories.vue?vue&type=style&index=0&id=0aea9578&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aea9578",
  null
  
)

export default component.exports